import { render, staticRenderFns } from "./contract-overview.container.vue?vue&type=template&id=235886e8&scoped=true&lang=pug"
import script from "./contract-overview.container.vue?vue&type=script&lang=ts"
export * from "./contract-overview.container.vue?vue&type=script&lang=ts"
import style0 from "./contract-overview.container.vue?vue&type=style&index=0&id=235886e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235886e8",
  null
  
)

export default component.exports